import React from "react";
import { ContentWrapper } from "./styles";

export function SidebarContent({ children }: React.PropsWithChildren) {
  return <ContentWrapper data-scroll-trigger>{children}</ContentWrapper>;
}
